import { render, staticRenderFns } from "./Inscripcion_est.vue?vue&type=template&id=610abf58"
import script from "./Inscripcion_est.vue?vue&type=script&lang=js"
export * from "./Inscripcion_est.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports